import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import "@fontsource/montserrat";
import LineWithDot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import { DOWNLOAD_EXCEL_ALLMENTORSHIP } from "../../../../common/constants/ApplicationUrl";
import MessagesTable from "./MessagesTable";
import machines from "./rightbottom.svg";
import GlobalSelectComponent from "../../../../common/SelectComponent";
import startupBtn from "../../../../../assets/svg/blueBtnFilter.svg";
import viewAllMentorListButton from "../../../../../assets/svg/purpleBtn.svg";
import { isLoading } from "../../../../common/dependencies/action/action";
import { useHistory } from "react-router-dom";
import "./style.scss";
// : "#838186"
import clsx from "clsx";
import {
  MENTOR_SEARCH_REQUEST_LIST,
  STARTUP_APPLICATION,
  SEARCH_LIST_COUNTERS,
  MENTORSHIP_ALL,
  MENTORSHIPS_COUNTER,
  GET_NAMES_DATA,
} from "../../../../common/constants/ApplicationUrl";
import { Button as MaterialButton } from "@material-ui/core";
import axios from "axios";
import Pagination from "react-js-pagination";
import Modal from "./Modal/modal";
import { connect } from "react-redux";
import ModalFilters from "../../../../common/modalFilter/index";
import api from "../../../../common/dependencies/utils/Api";

import * as moment from "moment";
import {
  Button,
  ClickAwayListener,
  IconButton,
  InputBase,
} from "@material-ui/core";
import { State } from "country-state-city";
import dropdownicon from "../../../../../assets/images/arrow.png";
import Select from "react-select";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "20px",
    paddingBottom: "150px",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  requestsStatusTy: {
    backgroundColor: "#816aaf",
    color: "white",
    fontFamily: "Montserrat",
    padding: "10px 10px",
    borderRadius: "8px",
    fontWeight: 600,
    width: "100%",
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px 50px",
    background:
      "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
  },
  messageIconWrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    borderRadius: "px",
  },
  lineWithDotContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "25px",
    marginRight: "15px",
  },
  lineWithDotUpper: {
    color: "#277acc",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
  },
  lineWithDot: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: 0,
  },
  lineWithDotLower: {
    color: "#816aaf",
    fontWeight: "bold",
    textAlign: "left",
    fontSize: "14px",
  },
  selectStartup: {
    fontSize: "16px",
    width: "180px",
    marginRight: "10px",
    whiteSpace: "nowrap",
    textAlign: "left",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginBottom: "10px",
    },
  },
  newMessageButtonWrapper: {
    display: "flex !important",
    justifyContent: "flex-end !important",
  },
  machines: {
    position: "absolute",
    height: "400px",
    bottom: 40,
    right: 20,
  },
  filterContainer2: {
    padding: "10px",
    display: "flex",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  cursorOnHover: {
    "&:hover": {
      cursor: "pointer",
    },
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lowerButtonsContainer: {
    padding: "0 35%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  sendRequestButton: {
    height: "88.0781px !important",
    maxWidth: "none",
  },
  tableContainer: {
    // padding: "10px 10px 20px 10px",
    margin: "0 7% 50px 7%",
    [theme.breakpoints.down("md")]: {
      margin: 0,
    },
  },
  upperDisplayButtonsContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  filterContainer: {
    padding: "60px 7% 0 7%",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  mentorSelect: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
}));

const types = {
  SEARCH_REQUESTS: "",
  MENTOR_REQUESTS_SENT: "RequestSent",
  ACCEPTED: "Accepted",
  PENDING: "Pending",
  DECLINED: "Declined",
};

const UpperDisplaySurface = (props) => {
  const {
    selectedMenu: selected,
    setSelectedMenu: setSelected,
    setActiveNow,
  } = props;
  const [counters, setCounters] = useState();

  let history = useHistory();

  useEffect(() => {
    localStorage.setItem("allMentorships", "allMentorships");
    setTimeout(() => {
      // localStorage.removeItem("activitySummary");
      localStorage.removeItem("allMentorList");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allStartupList");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("mentorMenu");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("startUpApplications");
      localStorage.removeItem("cohortApplication");
    }, 1000);
    if (
      history?.location?.state === "startUpDash" &&
      selected !== "RequestSent"
    )
      setSelected("RequestSent");
  }, [history?.location?.state]);
  React.useEffect(() => {
    props.openLoader();
    // axios({
    //   url: SEARCH_LIST_COUNTERS,
    //   method: "POST",
    //   data: {
    //     requestedBy:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(SEARCH_LIST_COUNTERS, {
        requestedBy:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        setCounters(res.data?.data);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  }, []);

  const classes = useStyles();

  const SelectedContainer = (props) => (
    <Box className={classes.lineWithDotContainer}>
      <p className={classes.lineWithDotUpper}>{props.content}</p>
      <img
        src={LineWithDot}
        className={classes.lineWithDot}
        alt="line with dot"
      />
    </Box>
  );

  const UnselectedContainer = (props) => (
    <Typography
      className={classes.cursorOnHover}
      onClick={() => {
        setSelected(props.type);
        setActiveNow(props.selectText);
      }}
      style={{
        fontFamily: "Montserrat",
        fontSize: "16px",
        fontWeight: "bold",
        color: "#838186",
        marginLeft: "15px",
      }}
    >
      {props.content}
    </Typography>
  );

  return (
    <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper elevation={3} className={classes.upperDisplay}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Box className={classes.messageIconWrapper}>
              <Typography
                className={clsx(classes.requestsStatusTy, "ttlmentos")}
              >
                TOTAL MENTORSHIPS
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            className={[
              classes.upperDisplayButtonsContainer,
              "mentorshiptooltiphideformb",
            ]}
          >
            {selected === types.SEARCH_REQUESTS ? (
              <div className="newuserTooltip nonselctcont">
                <SelectedContainer
                  type={types.SEARCH_REQUESTS}
                  content={
                    <>
                      ACTIVE:{" "}
                      {props.counterData ? props.counterData.active : "00"}
                    </>
                  }
                />
                <span className="tooltiptext   tooltip-bottom startupmentorship-01">
                  Click to View Active Applications
                </span>
              </div>
            ) : (
              <div className="newuserTooltip nonselctcont">
                <UnselectedContainer
                  type={types.SEARCH_REQUESTS}
                  selectText={"ACTIVE"}
                  content={
                    <>
                      ACTIVE:{" "}
                      {props.counterData ? props.counterData.active : "00"}
                    </>
                  }
                />
                <span className="tooltiptext   tooltip-bottom startupmentorship-01">
                  Click to View Active Applications
                </span>
              </div>
            )}
            {selected === types.MENTOR_REQUESTS_SENT ? (
              <div className="newuserTooltip nonselctcont">
                <SelectedContainer
                  type={types.MENTOR_REQUESTS_SENT}
                  content={
                    <>
                      CLOSED:{" "}
                      {props.counterData ? props.counterData.closed : "00"}
                    </>
                  }
                />
                <span
                  className="tooltiptext   tooltip-bottom startupmentorship-01"
                  // style={{ left: "50px", top: "35px", width: "230px" }}
                >
                  Click to View Closed Applications
                </span>
              </div>
            ) : (
              <div className="newuserTooltip nonselctcont">
                <UnselectedContainer
                  type={types.MENTOR_REQUESTS_SENT}
                  selectText={"CLOSED"}
                  content={
                    <>
                      CLOSED:{" "}
                      {props.counterData ? props.counterData.closed : "00"}
                    </>
                  }
                />
                <span
                  className="tooltiptext   tooltip-bottom startupmentorship-01"
                  // style={{ left: "50px", top: "35px", width: "230px" }}
                >
                  Click to View Closed Applications
                </span>
              </div>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

const MentorMessages = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const { getStepperTooltipData, getStepperData } = props;
  const classes = useStyles(0);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [data, setData] = React.useState();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [paginationData, setPaginationData] = React.useState();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalData, setModalData] = React.useState();
  const [modalVisibility, setModalVisibility] = React.useState();
  const [isParentData, setIsParentData] = React.useState("");
  const [selectedMenu, setSelectedMenu] = React.useState("");
  const [selectedRow, setSelectedRow] = React.useState(-1);
  let history = useHistory();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterIndustryKeyword, setFilterIndustryKeyword] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterFunctionKeyword, setFilterFunctionKeyword] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [counterData, setCounterData] = useState();
  const [activeNow, setActiveNow] = useState("ACTIVE");
  const [filterStartupName, setFilterStartupName] = useState("");
  const [filterStartupNameData, setFilterStartupNameData] = useState();
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  React.useEffect(() => {
    html.style.overflow = "auto";

    setCurrentPage(1);
  }, [selectedMenu]);

  React.useEffect(() => {
    if (isParentData !== "") {
      setTimeout(() => {
        getListDataFn();
      }, 3000);
    }
  }, [isParentData]);

  const getAllStartups = () => {
    // axios({
    //   url: GET_NAMES_DATA,
    //   method: "post",
    //   data: {
    //     listKey: "Startup",
    //   },
    // })
    api
      .POST(GET_NAMES_DATA, {
        listKey: "Startup",
      })
      .then((res) => {
        setFilterStartupNameData(res.data?.data);
      })
      .catch((err) => {});
  };

  React.useEffect(() => {
    props.getPredefineOptionsList();
    getListDataFn();
    getAllStartups();
  }, []);
  React.useEffect(() => {
    props.getPredefineOptionsList();
    getListDataFn();
  }, [activeNow]);

  const getListDataFn = () => {
    let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    props.openLoader();
    let data = {};
    if (filterFunction.value) {
      data.function = filterFunction.value;
    }
    if (filterIndustry.value) {
      data.industry = filterIndustry.value;
    }
    if (filterStage.value) {
      data.stage = filterStage.value;
    }
    if (filterFunctionKeyword.value) {
      data.sub_function = [filterFunctionKeyword.value];
    }
    if (filterIndustryKeyword.value) {
      data.sub_industry = [filterIndustryKeyword.value];
    }
    if (filterState.value) {
      data.state = filterState.value;
    }
    if (filterStartupName.value) {
      data.searchField = filterStartupName.value;
    }
    // axios({
    //   url: MENTORSHIP_ALL,
    //   method: "POST",
    //   data: {
    //     ...data,
    //     pageFilter: {
    //       pageSize: 10,
    //       currentPage: currentPage - 1,
    //       includeCount: true,
    //       sortField: "legalName",
    //       sortOrder: "DESC",
    //     },
    //     // status: history?.location?.state == "startUpDash" ? "RequestSent" :selectedMenu,
    //     status: activeNow,
    //   },
    // })
    api
      .POST(MENTORSHIP_ALL, {
        ...data,
        pageFilter: {
          pageSize: 10,
          currentPage: currentPage - 1,
          includeCount: true,
          sortField: "legalName",
          sortOrder: "DESC",
        },
        // status: history?.location?.state == "startUpDash" ? "RequestSent" :selectedMenu,
        status: activeNow,
      })
      .then((res) => {
        setData(res.data.data);
        setPaginationData(res.data.paginate);

        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };
  React.useEffect(() => {
    getListDataFn();
  }, [currentPage, selectedMenu]);

  React.useEffect(() => {
    getListDataFn();
  }, [filterStartupName]);

  const handleChangeOfPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleShow = () => {
    // setIsModalShown(true);
    setModalVisibility(true);
  };
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    //
    //
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  React.useEffect(() => {}, [modalVisibility]);

  const removeFirstItem = (arr, label) => {
    let newArr = arr?.filter((item, index) => index !== 0);
    newArr?.unshift({ value: "", label: label });
    return newArr;
  };

  const addNewItem = (arr, label) => {
    arr?.unshift({ value: "", label: label });
    return arr;
  };

  const states = State.getStatesOfCountry("IN").map((item) => ({
    value: item.name,
    label: item.name,
  }));

  const handleClickOfFilter = () => {
    setCurrentPage(1);
    getListDataFn();
    // props.openLoader();
    // let data = {

    // }
    // if(filterFunction.value) {
    //   data.function = filterFunction.value
    // }
    // if(filterIndustry.value) {
    //   data.industry = filterIndustry.value
    // }
    // if(filterStage.value) {
    //   data.stage = filterStage.value
    // }
    // if(filterFunctionKeyword.value) {
    //   data.sub_function = [filterFunctionKeyword.value]
    // }
    // if(filterIndustryKeyword.value) {
    //   data.sub_industry = [filterIndustryKeyword.value]
    // }
    // if(filterState.value) {
    //   data.state = filterState.value
    // }
    // let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    // axios({
    //   url: MENTORSHIP_ALL,
    //   method: "POST",
    //   data: {
    //     ...data,
    //     pageFilter: {
    //       currentPage: currentPage - 1,
    //       includeCount: true,
    //       pageSize: 10,
    //       sortField: "",
    //       sortOrder: "DESC",
    //     },
    //     status: selectedMenu
    //   },
    // })
    //   .then((res) => {
    //
    //     setData(res?.data?.data);
    //     setPaginationData(res?.data?.paginate);
    //     props.closeLoader();
    //   })
    //   .catch((err) => {
    //
    //     props.closeLoader();
    //   });
  };

  useEffect(() => {
    const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    // props.openLoader();
    // axios({
    //   url: MENTORSHIPS_COUNTER,
    //   method: "POST",
    //   data: {},
    // })
    api
      .POST(MENTORSHIPS_COUNTER, {})
      .then((res) => {
        setCounterData(res?.data?.data);
        // props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
  }, []);

  return (
    <Box className={classes.root}>
      <div
        className="dashboard-bottom-btn4 topbackbtnmentorlist "
        style={{ background: "transparent", border: "none" }}
      >
        <div className="newuserTooltip">
          <MaterialButton
            className="topbackbtnactual top-btn"
            variant="contained"
            color="primary"
            onClick={() => {
              localStorage.setItem(
                "startUpApplications",
                "startUpApplications"
              );

              window.location.reload();
            }}
            style={{
              background: "#3ac2d7",
              fontWeight: 600,
              fontFamily: "Montserrat",
            }}
          >
            {" "}
            Back
          </MaterialButton>
          <span
            className="tooltiptext tooltip-bottom"
            style={{
              top: "35px",
              width: "250px",

              left: "71px",
            }}
          >
            Click to Go Startup Applications
          </span>
        </div>
        <Modal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          modalData={modalData}
        />
        {modalVisibility && (
          <ModalFilters
            modalVisibility={modalVisibility}
            setModalVisibility={setModalVisibility}
            sendToParent={setIsParentData}
            showPurposeOfMentorship={true}
            fromPage={"myRequests"}
          />
        )}
      </div>
      <img src={machines} alt="machines" className={classes.machines} />
      <div className="iconWith-heading admindashmentorshipstartupappwith">
        <div style={{ width: "100%",paddingLeft:'10rem' }}>
          <Typography
            className={[
              classes.headingOne,
              "fadeInDown",
              "wow",
              "startupmentorshiphead1",
            ]}
          >
            MAARG Portal by Startup India
          </Typography>
          <Typography
            className={[
              classes.headingTwo,
              "fadeInDown",
              "wow",
              "startupmentorshiphead2",
            ]}
          >
            ALL MENTORSHIPS: STARTUPS
          </Typography>
        </div>
        <div  className='bothiconadjustment'>
            <a href={DOWNLOAD_EXCEL_ALLMENTORSHIP}>
              <div className="newuserTooltip">
                <img
                  className="excelButton excelbuttonadmindash"
                  src={excelButton}
                  style={{ top: "2.4rem", width: "47%", left: "1rem" }}
                ></img>
                <span
                  className="tooltiptext   tooltip-bottom admincohort01"
                  style={{ left: "1rem", top: "5.75rem", width: "13vw" }}
                >
                  Download Excel Report
                </span>
              </div>
            </a>
            
            </div>
        <div
          className="tooltipshow eyeIcon"
          // onClick={() => {
          //   // html.style.overflow = "hidden";

          //   if (html.style.overflow == "auto") {
          //     html.style.overflow = "hidden";
          //   } else {
          //     html.style.overflow = "auto";
          //   }
          // }}
        >
          <div className="newuserTooltip">
            <img
              className="iconbtn top-btn"
              src={iconTooltip}
              onClick={() => {
                setModalIsOpenToTrue();
                if (html.style.overflow == "auto") {
                  html.style.overflow = "hidden";
                } else {
                  html.style.overflow = "auto";
                }
              }}
              width={60}
            />{" "}
            <span
              className="tooltiptext tooltip-bottom "
              style={{ width: "130px", top: "50px", left: "20px" }}
            >
              View Instructions
            </span>
          </div>
        </div>
        {isShown && (
          <div>
            <AnimeList
              setModalIsOpenToTrue={setModalIsOpenToTrue}
              Heading={Heading}
              InstructionswithRole={InstructionswithRole}
              SelectPage={SelectPage}
            />
          </div>
        )}
      </div>

      <UpperDisplaySurface
        openLoader={props.openLoader}
        closeLoader={props.closeLoader}
        setSelectedMenu={setSelectedMenu}
        selectedMenu={selectedMenu}
        paginationData={paginationData}
        data={data}
        counterData={counterData}
        setActiveNow={setActiveNow}
      />

      <Box className={classes.filterContainer}>
        <div className={clsx("newuserTooltip", classes.mentorSelect)}>
          <Select
            className={clsx(
              "industryallmentorshipsstrtups",
              classes.selectStartup
            )}
            options={removeFirstItem(
              filterStartupNameData?.map((item) => ({
                value: item?.id,
                label: item?.name,
              })),
              "Search Startup"
            )}
            placeholder="Search Startup"
            styles={{
              menu: (styles) => {
                return {
                  ...styles,
                  width: "auto",
                };
              },
              option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                  ...styles,
                  backgroundColor: isSelected
                    ? "#b499c7"
                    : isFocused
                    ? "#e4d7ee"
                    : "white",
                  color: isSelected ? "white" : "black",
                  cursor: isDisabled ? "not-allowed" : "default",
                };
              },
            }}
            onChange={(selected) => setFilterStartupName(selected)}
          />
          <span
            className="tooltiptext tooltip-bottom"
            style={{ left: "70px", top: "45px", width: "130px" }}
          >
            Search Startup
          </span>
        </div>

        <Grid container spacing={1} alignItems="center">
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={clsx("industryallmentorshipsstrtups", classes.select)}
              options={removeFirstItem(
                props.selectOptions?.industry_options,
                "Select Industry"
              )}
              placeholder="Industry"
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterIndustry(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "65px", top: "47px", width: "130px" }}
            >
              Search Industry
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={clsx("industryallmentorshipsstrtups", classes.select)}
              placeholder="Keyword"
              options={removeFirstItem(
                props.selectOptions?.sub_industry,
                "Select Industry Keyword"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterIndustryKeyword(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "70px", top: "47px", width: "180px" }}
            >
              Search Industry Keyword
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Function"
              options={removeFirstItem(
                props.selectOptions?._specialisation,
                "Select Function"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterFunction(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "65px", top: "47px", width: "130px" }}
            >
              Search Function
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={clsx("industryallmentorshipsstrtups", classes.select)}
              placeholder="Keyword"
              onChange={(selected) => setFilterFunctionKeyword(selected)}
              options={removeFirstItem(
                props.selectOptions?.functional_areas,
                "Select Function Keyword"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "70px", top: "47px", width: "180px" }}
            >
              Search Function Keyword
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={[classes.selectContainer, "newuserTooltip"]}
          >
            <Select
              className={classes.select}
              placeholder="Stage"
              options={removeFirstItem(
                props.selectOptions?.stage_of_startup_options,
                "Select Stage"
              )}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                    minWidth: "100%",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
              onChange={(selected) => setFilterStage(selected)}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "65px", top: "47px", width: "130px" }}
            >
              Search Stage
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            className={["newuserTooltip", classes.selectContainer]}
          >
            <Select
              className={clsx("stateallmentorshipsstrtups", classes.select)}
              placeholder="State"
              options={addNewItem(states, "Select State")}
              onChange={(selected) => setFilterState(selected)}
              styles={{
                menu: (styles) => {
                  return {
                    ...styles,
                    width: "auto",
                    transform: "translateX(-100px)",
                  };
                },
                option: (
                  styles,
                  { data, isDisabled, isFocused, isSelected }
                ) => {
                  return {
                    ...styles,
                    backgroundColor: isSelected
                      ? "#b499c7"
                      : isFocused
                      ? "#e4d7ee"
                      : "white",
                    color: isSelected ? "white" : "black",
                    cursor: isDisabled ? "not-allowed" : "default",
                  };
                },
              }}
            />
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "65px", top: "47px", width: "130px" }}
            >
              Search State
            </span>
          </Grid>
        </Grid>
        <div className="top-btn newuserTooltip">
          <Button
            variant="contained"
            style={{
              marginLeft: "10px",
              fontFamily: "Montserrat",
              color: "#fff",
              fontSize: "16px",
              backgroundColor: "#3ac2d7",
            }}
            onClick={handleClickOfFilter}
          >
            GO
          </Button>
          <span className="tooltiptext filter  tooltip-bottom ">
            Click to Apply Filters
          </span>
        </div>
      </Box>

      <Typography
        className="tablecountformb"
        style={{
          textAlign: "right",
          marginBottom: "10px",
          marginTop: "10px",
          padding: "0  7%",
          fontFamily: "Montserrat",
          color: "rgba(0,0,0,0.5)",
          fontWeight: "bold",
        }}
      >
        {/* {`Total Items Found: ${
          paginationData ? parseInt(paginationData.totalElements) : ""
        } < ${paginationData?.currentPage} of ${paginationData?.numPages} >`} */}
        {`Total Items Found:`}
        {paginationData !== undefined &&
          ` ${paginationData ? parseInt(paginationData.totalElements) : ""} < ${
            paginationData?.currentPage
          } of ${paginationData?.numPages} >`}
      </Typography>
      <Paper className={classes.tableContainer} elevation={3}>
        <ClickAwayListener
          onClickAway={() => {
            setSelectedRow(-1);
          }}
        >
          <div>
            <MessagesTable
              setMentorMatchlistId={props.setMentorMatchlistId}
              setSelectedMenu={props.setSelectedMenu}
              setModalOpen={setModalOpen}
              setModalData={setModalData}
              data={data}
              currentPage={currentPage}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
            />
          </div>
        </ClickAwayListener>
        <div className="pagination-box">
          <Pagination
            activePage={currentPage}
            itemsCountPerPage={paginationData?.pageSize}
            totalItemsCount={paginationData?.totalElements}
            pageRangeDisplayed={5}
            onChange={handleChangeOfPage.bind(this)}
          />
        </div>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  selectOptions: state.AdminMentorListReducer.getPredefineOptionsList.list,
  getStepperData: state.AdminMentorReducer.getStepperList.list,
});

export default connect(mapStateToProps, {
  openLoader,
  closeLoader,
  getPredefineOptionsList,
  getStepperTooltipData,
})(MentorMessages);
